import React, { Component } from 'react';
import { connect } from 'react-redux';

import { changePostType } from '../../actions';

class PostTypes extends Component {
	constructor() {
		super();

		this.PostTypes = {
			posts    : 'Articles',
			book     : 'Books',
			event    : 'Events',
			protocol : 'Protocols',
			opinion  : 'Opinions',
		};
	}

	handleClick( e ) {
		this.props.changePostType( e.target.getAttribute("data-slug") );
	}

	renderPostTypes() {
		return Object.keys( this.PostTypes ).map( ( type ) => {
			return (
				<button className={ `btn btn-lg ${type === this.props.postType
					? 'active'
					: ''}` } onClick={ this.handleClick.bind( this ) } data-slug={ type }>{ this.PostTypes[ type ] }</button>
			);
		} );
	}

	render() {
		return (
			<div className="col-xs-12"><h2 className="filter-title">Filter by Content Type</h2>
				<div className="btn-group filter-wrapper filter-postType" role="group" aria-label="Content Type Filter" data-slug="all">
					{ this.renderPostTypes() }
				</div>
			</div>
		);
	}
}

function mapStateToProps( { postType } ) {
	return { postType };
}

export default connect( mapStateToProps, { changePostType } )( PostTypes );